import { UserState } from '@interfaces';

export const userInitialState: UserState = {
  user: {
    data: null,
    isLoading: false,
    error: null,
  },
};
